// @flow
import * as React from 'react'
import type { Coordinates } from 'types'
import { type AsyncResource, FailedToLoad } from 'framework'
import { MapEmbed, MapEmbedMarker } from 'ui/MapEmbed'
import Loader from 'ui/Loader'

type Props = {
  coordinates: AsyncResource<Coordinates>,
}

export default class GatheringPageMap extends React.Component<Props> {
  render = () => {
    const { coordinates } = this.props
    if (coordinates === FailedToLoad) return null
    if (!coordinates) return <Loader />

    return (
      <div className="GatheringPage-map">
        <MapEmbed centerLat={coordinates.lat} centerLng={coordinates.lng}>
          <MapEmbedMarker lat={coordinates.lat} lng={coordinates.lng} />
        </MapEmbed>
      </div>
    )
  }
}
